<div
  class="radius-dropdown"
  [class.radius-dropdown--open]="isDropdownOpen"
  [class.radius-dropdown--active]="isActive"
>
  <button
    class="radius-dropdown__button"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="toggleDropdown()"
  >
    <span class="radius-dropdown__button-text">
      {{ currentOption.text }}
    </span>
    <i
      class="radius-dropdown__button-icon material-icon material-icon--outlined"
    >
      arrow_drop_down
    </i>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isDropdownOpen"
    [cdkConnectedOverlayLockPosition]="true"
    [cdkConnectedOverlayWidth]="trigger.elementRef.nativeElement.clientWidth"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayGrowAfterOpen]="true"
    (overlayOutsideClick)="close()"
    (detach)="close()"
  >
    <lib-dropdown-menu
      [options]="options"
      [currentOption]="currentOption"
      (update)="select($event)"
      (tabOut)="close()"
    >
    </lib-dropdown-menu>
  </ng-template>
</div>
